// extracted by mini-css-extract-plugin
module.exports = {"source-type":"source-type___1l9NI"};